import { Injectable } from '@angular/core';
import { SocketService } from '@frontend/common/util';
import { createEffect } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import {
  GlobalCompletePatientWorkflowSuccessWs,
  GlobalCreatePatientWorkflowSuccessWs,
  GlobalRemovePatientWorkflowSuccessWs,
  GlobalUpdatePatientWorkflowSuccessWs,
  LocalCompletePatientWorkflowFailureWs,
  LocalCompletePatientWorkflowSuccessWs,
  LocalCreatePatientWorkflowFailureWs,
  LocalCreatePatientWorkflowSuccessWs,
  LocalRemovePatientWorkflowFailureWs,
  LocalRemovePatientWorkflowSuccessWs,
  LocalUpdatePatientWorkflowFailureWs,
  LocalUpdatePatientWorkflowSuccessWs,
} from './patient-workflow-ws.actions';

@Injectable()
export class PatientWorkflowWsEffects {
  LocalCreatePatientWorkflowSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('patient-workflows.create')
      .pipe(
        map(
          ({ id, correlation_id }) =>
            new LocalCreatePatientWorkflowSuccessWs({ id, correlation_id })
        )
      )
  );

  LocalCreatePatientWorkflowFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('patient-workflows.create')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalCreatePatientWorkflowFailureWs({ correlation_id, message })
        )
      )
  );

  LocalUpdatePatientWorkflowSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('patient-workflows.update')
      .pipe(
        map(
          ({ id, correlation_id }) =>
            new LocalUpdatePatientWorkflowSuccessWs({ id, correlation_id })
        )
      )
  );

  LocalUpdatePatientWorkflowFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('patient-workflows.update')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalUpdatePatientWorkflowFailureWs({ correlation_id, message })
        )
      )
  );

  LocalRemovePatientWorkflowSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('patient-workflows.remove')
      .pipe(
        map(
          ({ correlation_id }) =>
            new LocalRemovePatientWorkflowSuccessWs({ correlation_id })
        )
      )
  );

  LocalCompletePatientWorkflowSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalSuccess('patient-workflows.complete')
      .pipe(
        map(
          ({ correlation_id }) =>
            new LocalCompletePatientWorkflowSuccessWs({ correlation_id })
        )
      )
  );

  LocalCompletePatientWorkflowFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('patient-workflows.complete')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalCompletePatientWorkflowFailureWs({ correlation_id, message })
        )
      )
  );

  LocalRemovePatientWorkflowFailureWs$ = createEffect(() =>
    this.socketSrv
      .fromLocalError('patient-workflows.remove')
      .pipe(
        map(
          ({ correlation_id, message }) =>
            new LocalRemovePatientWorkflowFailureWs({ correlation_id, message })
        )
      )
  );

  GlobalCreatePatientWorkflowSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('patient-workflows.create')
      .pipe(
        map(
          (patientWorkflow: any) =>
            new GlobalCreatePatientWorkflowSuccessWs(patientWorkflow)
        )
      )
  );

  GlobalUpdatePatientWorkflowSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('patient-workflows.update')
      .pipe(
        map(
          (patientWorkflow: any) =>
            new GlobalUpdatePatientWorkflowSuccessWs(patientWorkflow)
        )
      )
  );

  GlobalRemovePatientWorkflowSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('patient-workflows.remove')
      .pipe(map(({ id }: any) => new GlobalRemovePatientWorkflowSuccessWs(id)))
  );

  GlobalCompletePatientWorkflowSuccessWs$ = createEffect(() =>
    this.socketSrv
      .fromGlobalSuccess('patient-workflows.complete')
      .pipe(map(({ id }: any) => new GlobalCompletePatientWorkflowSuccessWs(id)))
  );

  constructor(private socketSrv: SocketService) {}
}
